(() => {
  // Slider principal
  document.querySelectorAll('[data-rn-hero]').forEach((hero) => {
    const track = hero.querySelector('.rn-hero__track');
    const slides = hero.querySelectorAll('.rn-hero__slide');
    const dots = hero.querySelectorAll('[data-rn-dot]');
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const ms = Number(hero.dataset.intervalo) || 4000;
    const ir = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      dots.forEach((d, k) => d.setAttribute('aria-current', k === i ? 'true' : 'false'));
      slides.forEach((s, k) => s.toggleAttribute('inert', k !== i));
    };
    const reiniciar = () => {
      clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => ir(i + 1), ms);
    };
    hero.querySelector('[data-rn-prev]')?.addEventListener('click', () => { ir(i - 1); reiniciar(); });
    hero.querySelector('[data-rn-next]')?.addEventListener('click', () => { ir(i + 1); reiniciar(); });
    dots.forEach((d) => d.addEventListener('click', () => { ir(Number(d.dataset.rnDot)); reiniciar(); }));
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', reiniciar);
    ir(0);
    reiniciar();
  });

  // Flechas de las filas
  document.querySelectorAll('.rn-fila').forEach((fila) => {
    const lista = fila.querySelector('[data-rn-fila]');
    fila.querySelectorAll('[data-rn-mover]').forEach((b) =>
      b.addEventListener('click', () => lista.scrollBy({ left: Number(b.dataset.rnMover) * lista.clientWidth * 0.8, behavior: 'smooth' }))
    );
  });

  // Campañas con cuenta regresiva
  document.querySelectorAll('[data-rn-campana]').forEach((c) => {
    const inicio = Date.parse(c.dataset.inicio);
    const fin = Date.parse(c.dataset.fin);
    const dos = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const ahora = Date.now();
      if (!Number.isFinite(fin) || ahora > fin) { c.hidden = true; return false; }
      c.hidden = false;
      const objetivo = ahora < inicio ? inicio : fin;
      c.querySelector('[data-rn-etiqueta]').textContent = ahora < inicio ? 'Empieza en' : 'Termina en';
      const f = Math.max(0, objetivo - ahora);
      c.querySelector('[data-rn-d]').textContent = Math.floor(f / 86400000);
      c.querySelector('[data-rn-h]').textContent = dos(Math.floor(f / 3600000) % 24);
      c.querySelector('[data-rn-m]').textContent = dos(Math.floor(f / 60000) % 60);
      c.querySelector('[data-rn-s]').textContent = dos(Math.floor(f / 1000) % 60);
      return true;
    };
    if (tick()) setInterval(tick, 1000);
  });
})();
